import { useState, useRef, useEffect } from "react";
import Constants from "../Utilities/Constants";
import axios from "axios";
import { Link } from "react-router-dom";


const DeliveryAddress = ({data, setData, setComponent, setYishuv}) => {
    const [inputs, setInputs] = useState({});
    const [pickup, setPickup] = useState(false);
    const phoneRef = useRef(null);
    const [yishuvim, setYishuvim] = useState([]);
    const [selectedDistance, setSelectedDistance] = useState(null);
    const yishuvReference = useRef(null);

    // =====================================================================
    // TEST ONLY — Nominatim precise geocoding (uncomment to enable)
    // Replaces yishuv-centre distance with street-level distance.
    // Usage policy: max 1 req/sec, not for production bulk use.
    // const STORE_LAT = 32.027910;
    // const STORE_LON = 34.890615;
    // const geocodeAddress = async (address, yishuvName) => {
    //     if (!address || !yishuvName) return;
    //     try {
    //         const q = encodeURIComponent(`${address}, ${yishuvName}, Israel`);
    //         const res = await fetch(
    //             `https://nominatim.openstreetmap.org/search?q=${q}&format=json&limit=1`,
    //             { headers: { 'User-Agent': 'SuperCommerce-test' } }
    //         );
    //         const data = await res.json();
    //         if (data.length > 0) {
    //             const lat = parseFloat(data[0].lat);
    //             const lon = parseFloat(data[0].lon);
    //             const dLat = (lat - STORE_LAT) * Math.PI / 180;
    //             const dLon = (lon - STORE_LON) * Math.PI / 180;
    //             const a = Math.sin(dLat/2)**2 +
    //                 Math.cos(STORE_LAT * Math.PI / 180) * Math.cos(lat * Math.PI / 180) *
    //                 Math.sin(dLon/2)**2;
    //             const km = 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    //             setSelectedDistance(Math.round(km * 10) / 10);
    //         }
    //     } catch (e) {
    //         console.error('Nominatim error', e);
    //     }
    // };
    // END TEST ONLY
    // =====================================================================

    useEffect(() => {

        async function Yishuvim() {
            try {
                const response = await axios.get(Constants.API_URL_YISHUVIM);
                setYishuvim(response.data);
            }
            catch (error) {
                console.error(error);
            }
        }

        Yishuvim();
        setInputs(data);
        setPickup(data.pickup ?? false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (!data.yishuvId) return;
        const yishuv = yishuvim.find((e) => e.yishuvId === parseInt(data.yishuvId));
        setYishuv(yishuv);

        const el = document.getElementById("yishuvError");
        if (el) el.style.display = (yishuv && yishuv.zoneId === null) ? "block" : "none";

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [yishuvim])

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
        setData(values => ({...values, [name]: value}));
    }

    const handleYishuv = (event) => {
        var yishuv = yishuvim.find((e) => e.yishuvId === parseInt(event.target.value));
        if (!yishuv) return;

        setSelectedDistance(yishuv.distanceKm ?? null);
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}));
        setData(values => ({...values, [name]: value}));
        setYishuv(yishuv);

        const el = document.getElementById("yishuvError");
        if (el) el.style.display = yishuv.zoneId === null ? "block" : "none";
    }

    const handlePickupChange = (isPickup) => {
        setPickup(isPickup);
        setData(values => ({...values, pickup: isPickup}));
    }

    function validateCellular(cellPhone) {
        const regex = /^0(5[012345678]|6[47]){1}(-)?[^0\D]{1}\d{6}$/;
        const el = document.getElementById("phoneError");

        if (regex.test(cellPhone)) {
            if (el) el.style.display = "none";
            return true;
        }
        else {
            if (el) el.style.display = "block";
            phoneRef.current?.focus();
            return false;
        }
    }

    const handleProceed = () => {
        if (pickup) {
            if (!validateCellular(inputs.phoneNo ?? '')) return;
            setComponent('DeliverySelect');
            return;
        }

        if (!inputs.address?.trim()) {
            document.getElementById("address")?.focus();
            return;
        }

        const yishuv = yishuvim.find((e) => e.yishuvId === parseInt(inputs.yishuvId));
        if (!yishuv || yishuv.zoneId === null) {
            const el = document.getElementById("yishuvError");
            if (el) el.style.display = "block";
            yishuvReference.current.focus();
            return;
        }

        if (!validateCellular(inputs.phoneNo ?? '')) return;

        setComponent('DeliverySelect');
    }


    return (
        <>
        <div className="d-flex justify-content-between border-bottom border-success mb-4">
            <h4>אופן קבלת ההזמנה</h4>
        </div>

        <div className="d-flex gap-3 mb-4">
            <div onClick={() => handlePickupChange(false)}
                className="d-flex flex-column flex-sm-row align-items-center text-center text-sm-start gap-3"
                style={{
                    flex: 1, cursor: 'pointer', borderRadius: '12px', padding: '12px 16px', transition: 'all 0.2s',
                    border: !pickup ? '2px solid #198754' : '2px solid #dee2e6',
                    background: !pickup ? '#d1e7dd' : '#f8f9fa',
                    boxShadow: !pickup ? '0 2px 8px rgba(25,135,84,0.15)' : 'none',
                }}>
                <img src="/img/delivery1.png" alt="משלוח" style={{width: '48px', height: '48px', objectFit: 'contain', flexShrink: 0}} />
                <div>
                    <div style={{fontWeight: 600, fontSize: '1.05rem', color: !pickup ? '#146c43' : '#6c757d'}}>משלוח הביתה</div>
                    <div style={{fontSize: '0.82rem', color: !pickup ? '#198754' : '#adb5bd'}}>נשלח אליך ישירות</div>
                </div>
            </div>
            <div onClick={() => handlePickupChange(true)}
                className="d-flex flex-column flex-sm-row align-items-center text-center text-sm-start gap-3"
                style={{
                    flex: 1, cursor: 'pointer', borderRadius: '12px', padding: '12px 16px', transition: 'all 0.2s',
                    border: pickup ? '2px solid #0d6efd' : '2px solid #dee2e6',
                    background: pickup ? '#cfe2ff' : '#f8f9fa',
                    boxShadow: pickup ? '0 2px 8px rgba(13,110,253,0.15)' : 'none',
                }}>
                <img src="/img/pickup2.png" alt="איסוף" style={{width: '48px', height: '48px', objectFit: 'contain', flexShrink: 0}} />
                <div>
                    <div style={{fontWeight: 600, fontSize: '1.05rem', color: pickup ? '#084298' : '#6c757d'}}>איסוף עצמי</div>
                    <div style={{fontSize: '0.82rem', color: pickup ? '#0d6efd' : '#adb5bd'}}>איסוף מהחנות</div>
                </div>
            </div>
        </div>

        {pickup &&
        <div className="row mt-2">
            <div className="col-md-4 mb-3">
                <label htmlFor="phoneNo" className="form-label">טלפון <span className="text-danger">*</span></label>
                <input name="phoneNo" id="phoneNo" className="form-control" ref={phoneRef}
                    onBlur={(e) => { validateCellular(e.target.value); handleChange(e); }}
                    defaultValue={inputs.phoneNo} placeholder="05X-XXXXXXX" />
                <span id="phoneError" className="text-danger" style={{display:'none'}}>נא הקש מספר טלפון תקין</span>
            </div>
        </div>
        }

        {!pickup &&
        <form method="post">
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="address" className="form-label">כתובת <span className="text-danger">*</span></label>
                    <input name="address" id="address" className="form-control" defaultValue={inputs.address}
                        onBlur={(e) => {
                            handleChange(e);
                            // TEST ONLY — comment out next line to disable Nominatim geocoding
                            // const yishuv = yishuvim.find(y => y.yishuvId === parseInt(inputs.yishuvId));
                            // geocodeAddress(e.target.value, yishuv?.yishuvName);
                            // END TEST ONLY
                        }} />
                </div>

                <div className="col-md-3 mb-3">
                    <label htmlFor="yishuvId" className="form-label">ישוב <span className="text-danger">*</span></label>
                    <select name="yishuvId" id="yishuvId" className="form-select" onChange={handleYishuv} ref={yishuvReference} value={inputs.yishuvId || ""}>
                        <option value="">בחר ישוב...</option>
                        {yishuvim.filter(y => y.zoneId !== null).map((yishuv) => (
                            <option key={yishuv.yishuvId} value={yishuv.yishuvId}>
                                {yishuv.yishuvName}
                            </option>
                        ))}
                    </select>
                    <span id="yishuvError" className="text-danger" style={{display:'none'}}>אין משלוחים לישוב זה</span>
                    {selectedDistance !== null &&
                        <small className="text-muted">📍 מרחק מהחנות: <strong>{selectedDistance} ק"מ</strong></small>
                    }
                </div>

                <div className="col-md-3 mb-3">
                    <label htmlFor="phoneNo" className="form-label">טלפון <span className="text-danger">*</span></label>
                    <input name="phoneNo" id="phoneNo" className="form-control" ref={phoneRef}
                        onBlur={(e) => { validateCellular(e.target.value); handleChange(e); }} defaultValue={inputs.phoneNo}/>
                    <span id="phoneError" className="text-danger hidden">נא הקש מספר טלפון תקין</span>
                </div>
            </div>

            <div className="row">
                <div className="col-md-3 mb-3">
                    <label htmlFor="entrance" className="form-label">כניסה/קומה/דירה</label>
                    <input name="entrance" id="entrance" className="form-control" onBlur={handleChange} defaultValue={inputs.entrance}/>
                </div>
                <div className="col-md-3 mb-3">
                    <label htmlFor="intercom" className="form-label">אינטרקום</label>
                    <input name="intercom" id="intercom" className="form-control" onBlur={handleChange} defaultValue={inputs.intercom}/>
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="notes" className="form-label">הערות למשלוח</label>
                    <input name="notes" id="notes" className="form-control" onBlur={handleChange} defaultValue={inputs.notes}/>
                </div>
            </div>
        </form>
        }

        <br/>
        <div>בלחיצה על המשך הנני מאשר כי קראתי ואישרתי את <Link to="/page/תקנון-האתר" className="text-decoration-underline">התקנון</Link>.</div>
        <br />
        <button className="btn btn-primary" onClick={handleProceed}>{pickup ? 'המשך לבחירת מועד איסוף' : 'המשך לבחירת מועד משלוח'}</button>
        </>
    )
}

export default DeliveryAddress;
